export const transformProperties = (
  propertiesArray: any[],
): Record<string, any> => {
  if (!propertiesArray) return []
  return propertiesArray.reduce(
    (acc, { propertyName, propertyValue }) => {
      if (
        propertyValue &&
        typeof propertyValue === "object" &&
        "__typename" in propertyValue
      ) {
        const { __typename, ...rest } = propertyValue
        acc[propertyName] = rest
      } else {
        acc[propertyName] = propertyValue
      }
      return acc
    },
    {} as Record<string, any>,
  )
}
